import React from 'react';
import { CircularProgress } from '@mui/material';
import DropdownSelect from '../../../components/DropdownSelect';
import Icons from '../../../components/icons';
import { academicYears } from '../../../constants/academicYears';
import { ButtonContainer, StyledButton } from '../../Exams/styled';
import { PaperWrapper } from '../../common/styled';
import { SearchFiltersRow } from '../styled';
import { DropdownChangeEvent, SkillsSearchFiltersProps } from '../types';

const SkillsSearchFilters: React.FC<SkillsSearchFiltersProps> = ({
  academicYear,
  grade,
  division,
  gradeOptions,
  divisionOptions,
  isClassesLoading,
  isLoading,
  onAcademicYearChange,
  onGradeChange,
  onDivisionChange,
  onSearch
}) => {
  const handleAcademicYearChange = (e: DropdownChangeEvent) =>
    onAcademicYearChange(e.target.value as string);

  const handleGradeChange = (e: DropdownChangeEvent) =>
    onGradeChange(e.target.value as string);

  const handleDivisionChange = (e: DropdownChangeEvent) =>
    onDivisionChange(e.target.value as string);

  const isSearchDisabled = isLoading || !grade || !division || !academicYear;

  return (
    <PaperWrapper>
      <SearchFiltersRow>
        <DropdownSelect
          label='Academic Year'
          placeholder='Select Academic Year'
          name='academicYear'
          value={academicYear}
          options={academicYears}
          onChange={handleAcademicYearChange}
          loading={!!isClassesLoading && academicYears.length === 0}
        />
        <DropdownSelect
          label='Grade'
          name='grade'
          value={grade}
          options={gradeOptions.map((g) => ({ value: g, label: g }))}
          onChange={handleGradeChange}
          placeholder='Select Grade'
          loading={!!isClassesLoading && gradeOptions.length === 0}
        />
        <DropdownSelect
          label='Division'
          name='division'
          value={division}
          options={divisionOptions.map((d) => ({ value: d, label: d }))}
          onChange={handleDivisionChange}
          placeholder='Select Division'
          loading={!!isClassesLoading && divisionOptions.length === 0}
        />
      </SearchFiltersRow>
      <ButtonContainer>
        <StyledButton onClick={onSearch} disabled={isSearchDisabled}>
          <Icons.SearchWhiteOutlined style={{ marginRight: '6px' }} />
          {isLoading ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            'Search'
          )}
        </StyledButton>
      </ButtonContainer>
    </PaperWrapper>
  );
};

export default SkillsSearchFilters;
